<!-- HERO SECTION -->
<div class="hero override" [ngStyle]="{ 'margin-top': slice.primary.margin_top+'px', 'margin-bottom': slice.primary.margin_bottom+'px' }">
  @for (component of slice.primary.hero?.body; track component) {
    <div>
      <div>
        @switch (component.type) {
          @case ('image') {
            <app-component-hero-image [component]="component" [vehicleObject]="vehicle"></app-component-hero-image>
          }
        }
      </div>
    </div>
  }

  <div class="main-hero-section pr-4 pl-4 container">
    <mdb-card role="region" aria-live="polite">
      <mdb-card-body [ngStyle]="{ 'padding-top': slice.primary.hero?.padding_top+'px', 'padding-bottom': slice.primary.hero?.padding_bottom+'px', 'padding-left': slice.primary.hero?.padding_left+'px', 'padding-right': slice.primary.hero?.padding_right+'px' }">
        <mdb-card-title class="text-center">
          @for (component of slice.primary.hero?.body; track component) {
            <div>
              <div>
                @switch (component.type) {
                  @case ('icon_group') {
                    <app-component-icon-group [component]="component" [vehicleObject]="vehicle" ></app-component-icon-group>
                  }
                  @case ('icon') {
                    <app-component-icon [component]="component" [vehicleObject]="vehicle"></app-component-icon>
                  }
                  @case ('title') {
                    <app-component-title [component]="component" [vehicleObject]="vehicle"></app-component-title>
                  }
                  @case ('subtitle') {
                    <app-component-subtitle [component]="component" [vehicleObject]="vehicle"></app-component-subtitle>
                  }
                  @case ('body') {
                    <app-component-hero-body [component]="component" [vehicleObject]="vehicle"></app-component-hero-body>
                  }
                  @case ('icon_with_cta') {
                    <app-component-icon-with-cta [component]="component" [vehicleObject]="vehicle"></app-component-icon-with-cta>
                  }
                  <!-- <app-component-cta *ngSwitchCase="'cta'" [component]="component" [vehicleObject]="vehicle"></app-component-cta> -->
                }
              </div>
            </div>
          }
        </mdb-card-title>
        <mdb-card-text class="text-center">
          @for (component of slice.primary.hero?.body; track component) {
            <div>
              <div>
                @switch (component.type) {
                  @case ('cta') {
                    <app-component-cta [component]="component" [vehicleObject]="vehicle" (emitOpenModal)="openModal($event)"></app-component-cta>
                  }
                }
              </div>
            </div>
          }
        </mdb-card-text>
      </mdb-card-body>
    </mdb-card>
  </div>
</div>
